<template>
  <HKLModal
    ref="modal"
    :closeable="true"
    :size="modalSize"
    class="green-operation_status-lifecycle"
    :title="$t('tenancy.greenOperation.lifecycleTitle')"
  >
    <HKLTable
      class="lifecycle"
      :dataSource="histories"
      :columns="columns"
      sort="createdAt"
    />
    <div
      slot="footer"
      class="row align-center"
    >
      <HKLButton
        color="orange"
        action="ok"
        @click="close"
      />
    </div>
  </HKLModal>
</template>

<script>
import lodash from 'lodash'
import { computed, unref } from 'vue-demi'
import HKLButton from '@/controls/Button/HKLButton.vue'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import HKLTable from '@/controls/Table/HKLTable.vue'
import { useStoreGetters } from '@/store'
import dateUtil from '@/utils/dateUtil'
import i18n from '@/utils/i18n'
import userHelper from '@/utils/userHelper'
import { GREEN_OPERATION_HISTORY_TYPE, GREEN_OPERATION_SPP_REVIEW_STATUS } from './consts'
import { useGreenOperation } from './hook'
import { resolveSppLifecycleEffectiveDate } from './sppLifecycleEffectiveDate'

export default {
  components: {
    HKLButton,
    HKLTable,
    HKLModal,
  },
  props: {
    isSpp: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: null,
    },
  },
  setup (props) {
    const { data: currentGreenOperation } = useGreenOperation()
    const { setting } = useStoreGetters('settings', 'setting')
    const { open, modal, close } = useRefModal()
    const columns = [
      {
        title: i18n.t('table.header.status'),
        dataIndex: 'status',
        width: 200,
        emptyValue: i18n.t('emptyValue'),
      },
      {
        title: i18n.t('table.header.comment'),
        dataIndex: 'comment',
        emptyValue: '',
      },
      {
        title: i18n.t('table.header.username'),
        dataIndex: 'username',
        width: 140,
        emptyValue: i18n.t('emptyValue'),
      },
      {
        title: i18n.t('table.header.date'),
        dataIndex: 'date',
        width: 130,
        emptyValue: i18n.t('emptyValue'),
      },
    ]
    return {
      modalSize: 1000,
      modal,
      open,
      close,
      columns,
      histories: computed(() => {
        const lifecycleHistories = unref(currentGreenOperation).histories.filter(item => {
          return item.type === GREEN_OPERATION_HISTORY_TYPE.LIFECYCLE
        })
        const result = lifecycleHistories.filter(item => {
          return item.type === GREEN_OPERATION_HISTORY_TYPE.LIFECYCLE &&
            Boolean(lodash.get(item, 'detail.isSpp')) === props.isSpp
        }).map(item => {
          const who = lodash.get(item, 'who', {})
          const username = userHelper.getUserName(who.username, who.displayName)
          const date = dateUtil.format(item.createdAt, dateUtil.DD_MMM_YY_HH_MM)
          const status = i18n.t(`status.${item.status.toLowerCase()}`).toUpperCase()
          return {
            status,
            comment: item.detail.comment,
            username,
            date,
            createdAt: item.createdAt,
          }
        })
        if (props.isSpp && props.status === GREEN_OPERATION_SPP_REVIEW_STATUS.NEW && result.length === 0) {
          const createdAt = resolveSppLifecycleEffectiveDate(unref(setting))
          if (createdAt) {
            result.push({
              status: i18n.t(`status.${GREEN_OPERATION_SPP_REVIEW_STATUS.NEW.toLowerCase()}`).toUpperCase(),
              comment: '',
              username: i18n.t('system.user'),
              date: dateUtil.format(createdAt, dateUtil.DD_MMM_YY_HH_MM),
              createdAt,
            })
          }
        }
        return lodash.orderBy(result, 'createdAt').reverse()
      }),
    }
  },
}
</script>

<style lang="scss" scoped>
.green-operation_status-lifecycle {
  ::v-deep {
    .hkl-table {
      margin: 0;
    }
    .ant-modal-title {
      font-size: 18px;
    }
  }
}
</style>
